// Auto-generated by infra/scripts/stamp-version.js (deploy stamp).
// Gitignored — do not commit. Overwritten on every deploy.
export const KINDOO_WEB_VERSION = 'f6423c2';
export const KINDOO_WEB_BUILT_AT = '2026-09-09T03:23:30.502Z';
